<template>
  <div class="writer contents" ref="writer" data-editor-active>
    <h3 class="title" ref="title" data-grid-layout="title" >
      {{ this.titleText }}
    </h3>
    <div data-grid-layout="tl"> 
    </div>
    <table data-grid-layout="content" class="writer">
      <tbody>
        <tr>
          <th>이름</th><td>{{ userInfo.name }}</td>
          <th>이메일</th>
          <td v-if="!readonly">{{ userInfo.email }}</td>
          <td v-else>{{ optionInfo.emailActive ? userInfo.email : `(비공개)` }}</td>
        </tr>
        <tr>
          <th>소속(직장명)</th>
          <td v-if="!readonly">{{ userInfo.companyName }}</td>
          <td v-else>{{ optionInfo.companyNameActive ? userInfo.companyName : `(비공개)`  }}</td>
          <th>전화번호</th>
          <td v-if="!readonly">{{ userInfo.mobile }}</td>
          <td v-else>{{ optionInfo.mobileActive ? userInfo.mobile : `(비공개)` }}</td>
        </tr>
        <tr>
          <th>직책</th>
          <td v-if="!readonly">{{userInfo.position }}</td>
          <td v-else>{{ optionInfo.positionActive ? userInfo.position : `(비공개)` }}</td>
          <th>연구분야</th>
          <td v-if="!readonly">{{ userInfo.researchPart }}</td>
          <td v-else>{{ optionInfo.researchPartActive ? userInfo.researchPart : `(비공개)` }}</td>
        </tr>
        <tr>
          <th>연구자번호</th><td>{{ optionInfo.researchNumberActive ? userInfo.researchNumber : `(비공개)` }}</td>
          <!-- <th>권한</th><td>{{ optionInfo.belongActive ? userInfo.belong : `(비공개)` }}</td> -->
          <th>-</th><td></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import CommNew, {commNewMapMutations, commNewMapGetters} from "@processEditor/CommNew";
import { FormGroupPlugin } from "bootstrap-vue";

export default {
  props: {
    item: { type: Object, default: {} },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  mixins: [CommNew],
  data(){
    return {
      titleEdit: false,
      titleText: '작성자',
      protocolNumber : 0,
      userInfo : {},
      optionInfo : {}
    }
  },
  updated() {
    this.$emit('updated', {
			title : this.$refs.title,
			key: this.item.key || null,
			depth : 0,
      type: 'writer',
		})
  },
  async mounted() {
    // console.log('============= 작성자 =========')
    let response;
    let { protocols } = this.PROCESS_INFO ; 
    let { protocolId } = this.$route.query ; 
    let slctProtocol = protocols.filter( protocol => protocol.id == protocolId )[0] ; 
    this.updateProcessInfo({protocolId: slctProtocol.protocolId})

    if(slctProtocol) 
    // 테스트용
    // this.updateStatus({key: 'DocumentOption', bln:true})
    if(slctProtocol) {
      response = await this.$wApi.protocol.optionUser.get(null, slctProtocol.id);
      this.optionInfo = response;
      this.userInfo = response.user;
      this.updatePdfWiki({ writer : response.user }) ; // pdf 저장용( 작성자 ) 
    }
  },
  methods: {
    ...commNewMapMutations([
      'updateStatus' , 'updateProcessInfo'
		]),
  },

}
</script>
<style lang="scss">
  table.writer {
    th , td {
      border: 1px solid $gray-d !important;
      font-size: 14px; 
    }
    th {
      background-color: #EEF5FF !important;  
    }
  }
  
</style>